import { render } from "./ExamHeader.vue?vue&type=template&id=3aaac0e7&scoped=true"
import script from "./ExamHeader.vue?vue&type=script&lang=js"
export * from "./ExamHeader.vue?vue&type=script&lang=js"

import "./ExamHeader.vue?vue&type=style&index=0&id=3aaac0e7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aaac0e7"]])

export default __exports__